import React from 'react';
import { useSelector } from 'react-redux';

// Hooks
import { useOrganizationSubscription } from 'Shared/utils/hooks/use-organization-subscription';
import { useApp } from 'Shared/utils/hooks/use-app';
import { useTranslation } from 'Shared/contexts/TranslationsContext';

// Components
import WpBanner from 'Wpds/components/banner/WpBanner';
import { WpButton, WpButtonGroup } from 'Wpds/components/button';

// Styles
import './PlanTrialBanner.scss';

const PlanTrialBanner = () => {
  const { isTrialExpired } = useOrganizationSubscription();
  const { name } = useSelector(state => state?.organization);

  const { intercomContactSalesEventName } = useApp();
  const { tr } = useTranslation();

  if (!isTrialExpired) return null;

  const baseClassName = 'PlanTrialBanner';
  return (
    <WpBanner type="orange">
      <div className={baseClassName}>
        {tr('perform.banners.free_trial.expired_message', name || '')}
        <div className={`${baseClassName}__btn`}>
          <WpButtonGroup>
            <WpButton
              color="white"
              variant="primary"
              dataAttributes={{ 'data-intercom': intercomContactSalesEventName }}
            >
              {tr('perform.banners.free_trial.talk_to_sales')}
            </WpButton>
          </WpButtonGroup>
        </div>
      </div>
    </WpBanner>
  );
};

export default PlanTrialBanner;
